export default __webpack_public_path__ + "static/LogoFinalWhite-d2fcad36b514dea0d9eff169cc7232a8.png";